import Text from '@/shared-components/text/components/Text';

import './styles/AuthNavigation.css';

export default function AuthNavigation({ currentPage, setCurrentPage }) {
  const activeTab = ["login", "forgot"].includes(currentPage) ? "login" : "sign-up";

  return (
    <>
      <div className="auth-navigation__container">
        <button className={`auth-navigation__tab ${activeTab === "sign-up" ? "active" : ""}`} onClick={()=>setCurrentPage("sign-up")}>
          <Text className="auth-navigation__tab-text font-size-large">Sign up</Text>
        </button>
        
        <button className={`auth-navigation__tab ${activeTab === "login" ? "active" : ""}`} onClick={()=>setCurrentPage("login")}>
          <Text className="auth-navigation__tab-text font-size-large">Log in</Text>
        </button>
      </div>
    </>
  );
}
